import { render, staticRenderFns } from "./PaypalForm.vue?vue&type=template&id=becdf99e&scoped=true&"
import script from "./PaypalForm.vue?vue&type=script&lang=js&"
export * from "./PaypalForm.vue?vue&type=script&lang=js&"
import style0 from "./PaypalForm.vue?vue&type=style&index=0&id=becdf99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becdf99e",
  null
  
)

export default component.exports